
import React, { useEffect, useRef, useState } from "react";
import "./Header.scss";
import cart from "../../images/shopping_cart.png";
import { Link, NavLink } from "react-router-dom";
import * as headerActions from "../../actions/header";
import * as shopActions from "../../actions/shop";
import * as authActions from "../../actions/auth";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AuthForm from "../AuthForm/Auth";
import EmptyCartPop from "../EmptyCartPop/EmptyCartPop";
import LogoutForm from "../LogoutForm/LogoutForm";
import MainMenu from "../MainMenu/MainMenu";
import logo from "./../../images/logo.png";
import user from "./../../images/home/user.png";
import userLogout from "./../../images/home/logout.png";
import "./../../i18n";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import axios from "axios";
import formatPrice from "../../helpers/formatPrice";

import flagLt from "../../images/flags/LT.png";
import flagEn from "../../images/flags/GB.png";
import flagFin from "../../images/flags/FI.png";
import flagRu from "../../images/flags/RU.png";

const Header = (props) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const [cartSticky, setCartSticky] = useState(false);
  const langsRef = useRef(null);

  const currentLanguage = i18n.language || "lt";

  const flags = {
    lt: flagLt,
    en: flagEn,
    fin: flagFin,
    ru: flagRu,
  };

  const langLabels = {
    lt: "LT",
    en: "EN",
    fin: "FIN",
    ru: "RU",
  };

  // Load cart when user becomes authenticated.
  // Requisites are loaded once in App.js.
  useEffect(() => {
    if (props.isAuth) {
      props.getCart(history);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isAuth]);

  useEffect(() => {
    const handleScroll = () => {
      setCartSticky(window.scrollY > 120);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        props.langsOpen &&
        langsRef.current &&
        !langsRef.current.contains(e.target)
      ) {
        props.toggleLangs(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props.langsOpen, props]);

  const changeLanguage = async (language) => {
    const lang = String(language).toLowerCase();
    const frontendLang = lang === "fi" ? "fin" : lang;
    const backendLang = frontendLang.toUpperCase();

    // Save selected language locally.
    localStorage.setItem("lang", frontendLang);

    // Update interface.
    await i18n.changeLanguage(frontendLang);

    // Close dropdown.
    props.toggleLangs(false);

    if (props.isAuth) {
      // User is authenticated: save language to backend.
      sessionStorage.removeItem("pendingLoginLang");

      try {
        await axios.put(`/api/user/lang/${backendLang}`);
      } catch (err) {
        console.error("Could not save language to backend:", err);
      }
    } else {
      // Guest: synchronize language after successful login.
      sessionStorage.setItem("pendingLoginLang", frontendLang);
    }
  };

  const logoutHandler = () => {
    if (props.logout) {
      props.logout();
    }

    window.location = "/logout";
  };

  const openLogin = () => {
    history.push("/login");
  };

  const openCart = (e) => {
    if (!props.isAuth) {
      e.preventDefault();
      history.push("/login");
      return;
    }

    if (!props.cartAmount && props.showEmptyCart) {
      e.preventDefault();
      props.showEmptyCart();
    }
  };

  return (
    <>
      <header className="site-header">
        <div className="site-header__top">
          <div className="site-header__container">
            <a href="mailto:info@gudema.lt" className="site-header__email">
              info@gudema.lt
            </a>

            <div className="site-header__langs" ref={langsRef}>
              <button
                type="button"
                className="site-header__lang-current"
                onClick={() => props.toggleLangs(!props.langsOpen)}
              >
                <img src={flags[currentLanguage] || flagLt} alt="" />
                {langLabels[currentLanguage] || "LT"}
                <span>&gt;</span>
              </button>

              {props.langsOpen ? (
                <div className="site-header__lang-list">
                  {["lt", "en", "fin", "ru"].map((lang) => {
                    if (lang === currentLanguage) {
                      return null;
                    }

                    return (
                      <button
                        type="button"
                        key={lang}
                        onClick={() => changeLanguage(lang)}
                      >
                        <img src={flags[lang]} alt="" />
                        {langLabels[lang]}
                      </button>
                    );
                  })}
                </div>
              ) : null}
            </div>
          </div>
        </div>

        <div className="site-header__main">
          <div className="site-header__container">
            <Link to="/" className="site-header__logo">
              <img src={logo} alt="Gudema" />
            </Link>

            <nav className="site-header__nav">
              <NavLink exact to="/" activeClassName="active">
                {t("nav.home")}
              </NavLink>

              {!props.isAuth ? (
                <NavLink to="/about" activeClassName="active">
                  {t("nav.partner")}
                </NavLink>
              ) : null}

              <NavLink to="/contacts" activeClassName="active">
                {t("nav.contacts")}
              </NavLink>

              {props.isAuth ? (
                <NavLink to="/shop" activeClassName="active">
                  {t("nav.shop")}
                </NavLink>
              ) : null}
            </nav>

            <div className="site-header__actions">
              <a
                href="https://shop.floraplaza.nl/floraplaza/en/EUR/login?store=34356"
                target="_blank"
                rel="noreferrer"
                className="site-header__floraplaza"
              >
                Floraplaza
              </a>

              {props.isAuth ? (
                <button
                  type="button"
                  className="site-header__login site-header__logout"
                  onClick={logoutHandler}
                >
                  <img src={userLogout} alt="" />
                  {t("nav.logout")}
                </button>
              ) : (
                <button
                  type="button"
                  className="site-header__login"
                  onClick={openLogin}
                >
                  <img src={user} alt="" />
                  {t("nav.login")}
                </button>
              )}

              {props.isAuth ? (
                <div
                  className={
                    cartSticky
                      ? "site-header__cart-wrap site-header__cart-wrap--sticky"
                      : "site-header__cart-wrap"
                  }
                >
                  <NavLink
                    to="/cart"
                    className="site-header__cart"
                    activeClassName="active"
                    onClick={openCart}
                  >
                    <img src={cart} alt="" />

                    <span className="site-header__cart-count">
                      {props.cartAmount || 0}
                    </span>

                    <strong>{formatPrice(props.cartSum || 0)}</strong>
                  </NavLink>
                </div>
              ) : null}

              <button
                type="button"
                className="site-header__burger"
                onClick={props.toggleMenu}
                aria-label={t("common.menu")}
              >
                <span />
                <span />
                <span />
              </button>
            </div>
          </div>
        </div>
      </header>

      {props.authOpen ? <AuthForm /> : null}
      {props.emptyCartOpen ? <EmptyCartPop /> : null}
      {props.logoutOpen ? <LogoutForm /> : null}
      {props.menuOpen ? <MainMenu /> : null}
    </>
  );
};

const mapStateToProps = (state) => ({
  isAuth: !!state.auth.authUsername,

  menuOpen: state.header.menuIsOpen,
  langsOpen: state.header.langsOpen,
  authOpen: state.header.formIsOpen,
  emptyCartOpen: state.header.emptyCartOpen,
  logoutOpen: state.header.logoutOpen,

  cartAmount: state.shop.cartAmount,
  cartSum: state.shop.cartSum,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(headerActions, dispatch),
  ...bindActionCreators(shopActions, dispatch),
  ...bindActionCreators(authActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
